<template>
  <div class="knowledgeMarket">
    <div style="position: relative;z-index: 1000;">
      <nav-bar @searchInfo="searchInfo" ref="searchInfoContainer"></nav-bar>
    </div>
    <div>
      <knowledge-search ref="knowledgeSearchContainer" @searchInfo="searchInfo"></knowledge-search>
    </div>
  </div>
</template>

<script>
  import navBar from '@/components/navBar'
  import knowledgeSearch from '@/components/knowledgeSearch' //知识市场搜索
  export default ({
    name: 'knowledgeMarket',
    components: {
      navBar,
      knowledgeSearch
    },
    data() {
      return {
        searchText: '',//搜索文本
        searchType: '',//搜素框商品目录
        pageNo: this.$store.state.defaultPageNo!=undefined?this.$store.state.defaultPageNo:0,
        pageSize: this.$store.state.defaultPageSize!=undefined?this.$store.state.defaultPageSize:10
      }
    },
    created: function() { //登录后的状态数据 ，前台手动加，后台联调后删除这个方法
      this.searchText =  this.$route.query.searchText==undefined?'':this.$route.query.searchText;
      this.searchType =  this.$route.query.searchType==undefined?'':this.$route.query.searchType;
      //隐藏商品目录id
      let hiddenSearchType =  this.$route.query.hiddenSearchType==undefined?'':this.$route.query.hiddenSearchType;
      this.searchInfo({'hiddenSearchType':hiddenSearchType});
    },
    mounted:function(){
      //更新查询框内的查询参数显示值
      this.$refs.searchInfoContainer.initSearchParams({'searchText':this.searchText,'searchType':this.searchType});
    },
    methods: {
      //更新查询参数
      initParams: function(param_) {
        let this_ = this;
        let data_ = {};
        let searchType = '';
        if (param_.searchText != undefined) {
          this_.searchText = param_.searchText;
        }
        if (param_.searchType != undefined) {
          this_.searchType = param_.searchType;
          searchType = this_.searchType;
        }
        //隐藏商品目录id(只使用一次)
        if (param_.hiddenSearchType != undefined&&!this_.searchType) {
          searchType = param_.hiddenSearchType;
        }
        //是否过滤我的知识   true 是  false 否
        let showSelf = '';
        if (param_.showSelf != undefined) {
          showSelf = param_.showSelf;
        }else{
          //获取我的知识
          if(this.$refs.knowledgeSearchContainer!=undefined&&this.$refs.knowledgeSearchContainer.switchflag!=undefined)
          showSelf = this.$refs.knowledgeSearchContainer.switchflag;
        }

        if (param_.pageNo != undefined) {
          this_.pageNo = param_.pageNo;
        } else {
          this_.pageNo = this_.$store.state.defaultPageNo;
        }
        if (param_.pageSize != undefined) {
          this_.pageSize = param_.pageSize;
        } else {
          this_.pageSize = this_.$store.state.defaultPageSize;
        }
        data_ = {
          'pageNo': this_.pageNo,
          'pageSize': this_.pageSize,
          'searchText': this_.searchText,
          'searchType': searchType,
          'showSelf':showSelf
        };
        return data_;
      },
      //搜索触发方法
      searchInfo: function(params) {
        let this_ = this;
        //更新查询参数
        let data_ = this_.initParams(params);

        //是否刷新结果头
        if(params.reloadSearchTitle===undefined||params.reloadSearchTitle==='true'||params.reloadSearchTitle===true){
          this_.searchInfoTitle(data_);
        }

        //组装查询
        let paramdata = {};
        paramdata.url = '/SJHG/publicplat/home/home/searchGoodsList';
        paramdata.data = data_; //json对象
        paramdata.onSuccess = function(res) {
          console.log("",res.data);
          //设置查询头信息
          this_.$refs.knowledgeSearchContainer.loadSearchText(this_.searchText);
          if (res.data.ok) {
            var resultdata = res.data.result;
            this_.$refs.knowledgeSearchContainer.loadSearchResult(resultdata);
          } else {
            console.log('查询商品失败');
          }
        };
        paramdata.onFailed = function(res) {
          console.log(res);
        };
        this_.$axiosUtil.postServer(paramdata);

      },
      //搜索结果分类
      searchInfoTitle: function(param_) {
        let this_ = this;
        //组装查询
        let paramdata = {};
        paramdata.url = '/SJHG/publicplat/home/home/searchGoodsListCatalogue';
        paramdata.data = param_; //json对象
        paramdata.onSuccess = function(res) {
          if (res.data.ok) {
            this_.$refs.knowledgeSearchContainer.loadSearchTitleResult(res.data.rows);
          } else {
            console.log('查询商品目录分类下商品数量失败');
          }
        };
        paramdata.onFailed = function(res) {
          console.log(res);
        };
        this_.$axiosUtil.postServer(paramdata);

      }
    }
  })
</script>

<style scoped>
  .knowledgeMarket {
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/page/knowledgeMarket.vue